// extracted by mini-css-extract-plugin
module.exports = {"tweet":"tweet-module--tweet--XYrjg","at":"tweet-module--at--1w_Wc","wiggle":"tweet-module--wiggle--1RDYF"};